import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    overflowY: 'auto',
    margin: '1rem',
    border: '1px solid #F1F1F1',
    borderRadius: '1rem',
    width: '25%',
    minHeight: '300px',
    height: '300px',
    maxHeight: '300px',
    cursor: 'default',
    background: 'white',

    [theme.breakpoints.down('lg')]: {
      overflowX: 'hidden',
      margin: 'auto auto 1rem auto',
      border: 'none',
      borderRadius: '0',
      width: '100%'
    }
  },

  header: {
    zIndex: 2,
    position: 'sticky',
    top: 0,
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    backgroundColor: 'white'
  },

  title: {
    margin: '1rem 0',
    textAlign: 'center',
    fontSize: theme.size.sm
  }
}))

export default useStyles
